import { render, staticRenderFns } from "./OpportunityItem.vue?vue&type=template&id=dae404bc"
import script from "./OpportunityItem.vue?vue&type=script&lang=js"
export * from "./OpportunityItem.vue?vue&type=script&lang=js"
import style0 from "./OpportunityItem.vue?vue&type=style&index=0&id=dae404bc&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports